// extracted by mini-css-extract-plugin
export default {"tooltip":"xP-z","arrow":"yP-z"};